import { useLocation } from "react-router-dom";
import { useTour } from "./TourProvider";
import { routeToChapter } from "./chapters";

/** Header control that replays the current page's chapter (spec §4.8). */
export function TourButton(): JSX.Element | null {
  const { state, start } = useTour();
  const { pathname } = useLocation();
  const chapterId = routeToChapter(pathname);
  if (chapterId === null) return null;
  return (
    <button
      type="button"
      data-tour="header.tour"
      aria-label="Start the tour for this page"
      disabled={state.active}
      onClick={() => start(chapterId, "replay")}
      style={{
        padding: "5px 13px",
        background: "#252525",
        color: "#bbb",
        border: "1px solid #3a3a3a",
        borderRadius: 4,
        cursor: "pointer",
        fontSize: 12,
      }}
    >
      ? Tour
    </button>
  );
}
